var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('sm-text',{staticClass:"sm__text-link",attrs:{"text":_vm.text,"format":_vm.format}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }